import React from 'react';
import TagBadge, { TagBadgeType } from './TagBadge';
import keyIcon from '../../../assets/images/icon_key_circle.png';

type OwnerBadgeProps = {
  type?: TagBadgeType;
  useText?: boolean;
};
const OwnerBadge = (props: OwnerBadgeProps) => {
  const { type = TagBadgeType.Normal, useText = true } = props;
  return <TagBadge type={type} text={useText ? 'Owner' : undefined} icon={keyIcon} />;
};

export default OwnerBadge;
